// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Bfiuz9pRXoebaTr7khKy {
  display: grid;
  align-items: center;
  justify-items: center;
  min-height: 1px;
  /* fix for iPhone XS */
  width: var(--jp-panel-width);
  min-width: var(--jp-panel-width);
  position: relative;
  opacity: 0;
  transition: opacity 0.4s ease-out;
}
.Bfiuz9pRXoebaTr7khKy[data-is-fully-loaded='true'] {
  opacity: 1;
}
.afN4WswZdIt9qP1NTgyX {
  display: grid;
  grid-column: 1 / -1;
  /* span both columns */
}
.RX0i2aLt_TYHIfwhBgri {
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* two columns total */
  place-items: center;
  row-gap: 3px;
  max-width: calc(var(--jp-panel-width) - 32px);
  /* Constrain content within panel */
}
.m0GF0I8dlcNtRx4tZrc_ {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border-radius: 6px;
  padding-top: var(--jp-level-padding-top);
}
.m0GF0I8dlcNtRx4tZrc_[data-clickable='true'] {
  cursor: pointer;
}
.RM1XPJxeuT3NulrtrghC {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  z-index: 0;
  pointer-events: none;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  color: var(--white-color);
}
/* Level-specific styling - using assets as backgrounds */
.wuqk11tyCDeksftk1eJt {
  width: var(--jp-grand-width);
  height: var(--jp-grand-height);
  font-size: var(--jp-grand-font-size);
  grid-column: 1 / -1;
  /* span both columns */
}
.wuqk11tyCDeksftk1eJt > span {
  font-size: var(--jp-grand-currency-font-size);
}
.wuqk11tyCDeksftk1eJt > span.AfpkzpV2BNBhvxXava2A {
  padding-top: var(--jp-boost-grand-currency-top);
}
.PyE3YXPbTgdvt3znhPwy {
  width: var(--jp-major-width);
  height: var(--jp-major-height);
  font-size: var(--jp-major-font-size);
  grid-column: 1 / -1;
  /* span both columns */
}
.PyE3YXPbTgdvt3znhPwy > span {
  font-size: var(--jp-major-currency-font-size);
}
.PyE3YXPbTgdvt3znhPwy > span.hS52OA8nBBYpRac5GFO_ {
  padding-top: var(--jp-boost-major-currency-top);
}
.leDparwtmLd2TJzSMe6T {
  width: var(--jp-minor-width);
  height: var(--jp-minor-height);
  font-size: var(--jp-minor-font-size);
  margin-left: 8px;
}
.leDparwtmLd2TJzSMe6T > span > span {
  font-size: var(--jp-minor-currency-font-size);
}
.X8RfrVjmKz1dN8dxs_hQ {
  width: var(--jp-mini-width);
  height: var(--jp-mini-height);
  font-size: var(--jp-mini-font-size);
}
.X8RfrVjmKz1dN8dxs_hQ > span {
  font-size: var(--jp-mini-currency-font-size);
}
.hHfNVUASmEPPf28fQLMh {
  position: var(--jp-currency-position);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-left: var(--jp-currency-margin-left);
  margin-right: 4px;
  font-family: var(--jp-currency-font-family);
  font-weight: 900;
  color: var(--jp-currency-color);
}
.FhRj5BrGhejLh6_BCT8C {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.FhRj5BrGhejLh6_BCT8C > span {
  display: grid;
  place-items: center;
  width: auto;
  height: var(--jp-currency-span-height, 0.9em);
  line-height: var(--jp-currency-line-height);
}
._lgBIyF29BXoJEBfPiPU {
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.KoehlHwY8sgya573In9l {
  font-family: var(--jp-font-family);
  font-weight: var(--jp-value-font-weight);
  color: var(--jp-currency-color);
  text-align: var(--jp-level-value-align);
  white-space: nowrap;
  flex: 1;
  padding-right: var(--jp-level-value-padding-right, 5px);
  padding-left: var(--jp-level-value-padding-left, 0px);
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: var(--jp-level-value-align);
  min-width: 0;
  overflow: visible;
  height: 100%;
}
.E4Mh95Ox_rQik3WjTGVJ {
  position: absolute;
  top: var(--jp-boost-label-top);
  left: var(--jp-boost-label-left);
  width: var(--jp-boost-label-width);
  z-index: 1;
}
.ECRQfKBIFh2Wp26_OjlG {
  position: absolute;
  font-family: var(--font-family-secondary);
  font-weight: 800;
  font-size: 18px;
  line-height: 100%;
  text-align: center;
  vertical-align: middle;
  background: linear-gradient(178.8deg, #FFE23E 27.08%, #FFB31F 72.34%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.KoehlHwY8sgya573In9l.AfpkzpV2BNBhvxXava2A {
  top: var(--jp-boost-level-value-top);
}
.KoehlHwY8sgya573In9l.hS52OA8nBBYpRac5GFO_ {
  top: var(--jp-boost-level-value-top);
}
.ZrUBJEe_3VgZ0k1TapjU {
  display: inline-block;
  font-family: inherit;
  font-weight: inherit;
  color: inherit;
  text-shadow: inherit;
  white-space: nowrap;
  position: relative;
  font-variant-numeric: tabular-nums;
  min-width: 0;
  overflow: visible;
}
/* Remove duplicate levelValue declaration and old animation styles */
/* Animation is now handled by JackpotAnimationManager */
/*Responsive adjustments - using CSS variables for consistency */
@media (max-width: 1025px) {
  .Bfiuz9pRXoebaTr7khKy {
    --jp-panel-width: 352px;
    --jp-grand-width: 304px;
    --jp-major-width: 250px;
    --jp-minor-width: 142px;
    --jp-mini-width: 142px;
    --jp-grand-font-size: 37px;
    --jp-major-font-size: 32px;
    --jp-minor-font-size: 19px;
    --jp-mini-font-size: 19px;
  }
}
@media (orientation: portrait) {
  .tBtOEBF2bEkwNt1EGnHQ {
    margin-bottom: 14px;
  }
}
div[data-view='single'] .tBtOEBF2bEkwNt1EGnHQ {
  margin-bottom: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/features/jackpots/components/StandardJackpot/StandardJackpot.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,4BAA4B;EAC5B,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,iCAAiC;AACnC;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;EAC7C,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA,yDAAyD;AACzD;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,mCAAmC;AACrC;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,qCAAqC;EACrC,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,2CAA2C;EAC3C,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6CAA6C;EAC7C,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,OAAO;EACP,uDAAuD;EACvD,qDAAqD;EACrD,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gCAAgC;EAChC,kCAAkC;EAClC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qEAAqE;EACrE,qBAAqB;EACrB,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,iBAAiB;AACnB;AACA,qEAAqE;AACrE,wDAAwD;AACxD,gEAAgE;AAChE;EACE;IACE,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".standardJackpot {\n  display: grid;\n  align-items: center;\n  justify-items: center;\n  min-height: 1px;\n  /* fix for iPhone XS */\n  width: var(--jp-panel-width);\n  min-width: var(--jp-panel-width);\n  position: relative;\n  opacity: 0;\n  transition: opacity 0.4s ease-out;\n}\n.standardJackpot[data-is-fully-loaded='true'] {\n  opacity: 1;\n}\n.panelIcon {\n  display: grid;\n  grid-column: 1 / -1;\n  /* span both columns */\n}\n.levelsContainer {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  /* two columns total */\n  place-items: center;\n  row-gap: 3px;\n  max-width: calc(var(--jp-panel-width) - 32px);\n  /* Constrain content within panel */\n}\n.level {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border-radius: 6px;\n  padding-top: var(--jp-level-padding-top);\n}\n.level[data-clickable='true'] {\n  cursor: pointer;\n}\n.levelBackgroundImage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  z-index: 0;\n  pointer-events: none;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  color: var(--white-color);\n}\n/* Level-specific styling - using assets as backgrounds */\n.level_grand {\n  width: var(--jp-grand-width);\n  height: var(--jp-grand-height);\n  font-size: var(--jp-grand-font-size);\n  grid-column: 1 / -1;\n  /* span both columns */\n}\n.level_grand > span {\n  font-size: var(--jp-grand-currency-font-size);\n}\n.level_grand > span.level_boost_grand {\n  padding-top: var(--jp-boost-grand-currency-top);\n}\n.level_major {\n  width: var(--jp-major-width);\n  height: var(--jp-major-height);\n  font-size: var(--jp-major-font-size);\n  grid-column: 1 / -1;\n  /* span both columns */\n}\n.level_major > span {\n  font-size: var(--jp-major-currency-font-size);\n}\n.level_major > span.level_boost_major {\n  padding-top: var(--jp-boost-major-currency-top);\n}\n.level_minor {\n  width: var(--jp-minor-width);\n  height: var(--jp-minor-height);\n  font-size: var(--jp-minor-font-size);\n  margin-left: 8px;\n}\n.level_minor > span > span {\n  font-size: var(--jp-minor-currency-font-size);\n}\n.level_mini {\n  width: var(--jp-mini-width);\n  height: var(--jp-mini-height);\n  font-size: var(--jp-mini-font-size);\n}\n.level_mini > span {\n  font-size: var(--jp-mini-currency-font-size);\n}\n.currency {\n  position: var(--jp-currency-position);\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  margin-left: var(--jp-currency-margin-left);\n  margin-right: 4px;\n  font-family: var(--jp-currency-font-family);\n  font-weight: 900;\n  color: var(--jp-currency-color);\n}\n.currencyText {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.currencyText > span {\n  display: grid;\n  place-items: center;\n  width: auto;\n  height: var(--jp-currency-span-height, 0.9em);\n  line-height: var(--jp-currency-line-height);\n}\n.levelIcon {\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.levelValue {\n  font-family: var(--jp-font-family);\n  font-weight: var(--jp-value-font-weight);\n  color: var(--jp-currency-color);\n  text-align: var(--jp-level-value-align);\n  white-space: nowrap;\n  flex: 1;\n  padding-right: var(--jp-level-value-padding-right, 5px);\n  padding-left: var(--jp-level-value-padding-left, 0px);\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: var(--jp-level-value-align);\n  min-width: 0;\n  overflow: visible;\n  height: 100%;\n}\n.boostLabel {\n  position: absolute;\n  top: var(--jp-boost-label-top);\n  left: var(--jp-boost-label-left);\n  width: var(--jp-boost-label-width);\n  z-index: 1;\n}\n.boostValue {\n  position: absolute;\n  font-family: var(--font-family-secondary);\n  font-weight: 800;\n  font-size: 18px;\n  line-height: 100%;\n  text-align: center;\n  vertical-align: middle;\n  background: linear-gradient(178.8deg, #FFE23E 27.08%, #FFB31F 72.34%);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.levelValue.level_boost_grand {\n  top: var(--jp-boost-level-value-top);\n}\n.levelValue.level_boost_major {\n  top: var(--jp-boost-level-value-top);\n}\n.numberValue {\n  display: inline-block;\n  font-family: inherit;\n  font-weight: inherit;\n  color: inherit;\n  text-shadow: inherit;\n  white-space: nowrap;\n  position: relative;\n  font-variant-numeric: tabular-nums;\n  min-width: 0;\n  overflow: visible;\n}\n/* Remove duplicate levelValue declaration and old animation styles */\n/* Animation is now handled by JackpotAnimationManager */\n/*Responsive adjustments - using CSS variables for consistency */\n@media (max-width: 1025px) {\n  .standardJackpot {\n    --jp-panel-width: 352px;\n    --jp-grand-width: 304px;\n    --jp-major-width: 250px;\n    --jp-minor-width: 142px;\n    --jp-mini-width: 142px;\n    --jp-grand-font-size: 37px;\n    --jp-major-font-size: 32px;\n    --jp-minor-font-size: 19px;\n    --jp-mini-font-size: 19px;\n  }\n}\n@media (orientation: portrait) {\n  .noLinkedJackpots {\n    margin-bottom: 14px;\n  }\n}\ndiv[data-view='single'] .noLinkedJackpots {\n  margin-bottom: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"standardJackpot": `Bfiuz9pRXoebaTr7khKy`,
	"panelIcon": `afN4WswZdIt9qP1NTgyX`,
	"levelsContainer": `RX0i2aLt_TYHIfwhBgri`,
	"level": `m0GF0I8dlcNtRx4tZrc_`,
	"levelBackgroundImage": `RM1XPJxeuT3NulrtrghC`,
	"level_grand": `wuqk11tyCDeksftk1eJt`,
	"level_boost_grand": `AfpkzpV2BNBhvxXava2A`,
	"level_major": `PyE3YXPbTgdvt3znhPwy`,
	"level_boost_major": `hS52OA8nBBYpRac5GFO_`,
	"level_minor": `leDparwtmLd2TJzSMe6T`,
	"level_mini": `X8RfrVjmKz1dN8dxs_hQ`,
	"currency": `hHfNVUASmEPPf28fQLMh`,
	"currencyText": `FhRj5BrGhejLh6_BCT8C`,
	"levelIcon": `_lgBIyF29BXoJEBfPiPU`,
	"levelValue": `KoehlHwY8sgya573In9l`,
	"boostLabel": `E4Mh95Ox_rQik3WjTGVJ`,
	"boostValue": `ECRQfKBIFh2Wp26_OjlG`,
	"numberValue": `ZrUBJEe_3VgZ0k1TapjU`,
	"noLinkedJackpots": `tBtOEBF2bEkwNt1EGnHQ`
};
export default ___CSS_LOADER_EXPORT___;
